import {VAT_OBJEKT_MODEL_COPY} from '@vat/vat-copy';

/**
 * SKR03-Kontonamen für die Objekt-Abrechnung (Spec 2.2). Die Kontonummern selbst kommen aus dem kundenspezifischen
 * `DatevPaymentsMapping` (Standard `DEFAULT_DATEV_PAYMENTS_MAPPING`); unbekannte Nummern werden als „Konto {nr}“ ausgewiesen.
 *
 * @author Anthony Nahas
 * @since 13.09.26
 */
export const VAT_KONTO_LABELS: Record<string, string> = {
    '8105': 'Mieteinnahmen Wohnraum (steuerfrei)',
    '8010': 'Mieteinnahmen Gewerbe',
    '8106': 'Betriebskosten-Vorauszahlungen',
    '8107': 'Heizkosten-Vorauszahlungen',
    '8200': 'Sonstige Erlöse',
    '2650': 'Sonstige Zinsen und Erträge',
    '1732': 'Erhaltene Kautionen',
};

export const kontoLabel = (konto: string): string => {
    const key = String(konto ?? '').trim();
    return VAT_KONTO_LABELS[key] ?? VAT_OBJEKT_MODEL_COPY.kontoFallback(key);
};
